import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  avatarRoot: {
    display: "flex",
    "& > *": {
      margin: ({ margin }) => theme.spacing(margin)
    }
  },
  avatarClass: {
    width: ({ size }) => theme.spacing(size / 8),
    height: ({ size }) => theme.spacing(size / 8),
    margin: ({ toolbar }) => toolbar && theme.spacing(-0.3, 0, 0.3, 0),
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.customShadows(theme.palette.primary.main),
    background: "white"
  }
}));
